<ng-container *ngIf="config$ | async as config">
  <ng-container *ngIf="basket$ | async as basket">
    <nav class="app-nav">
      <div class="nav-buttons">
        <button class="home-button" (click)="openHome()">
          <i class="material-icons">home</i>
        </button>
        <button class="home-button" (click)="fullScreen()">
          <i class="material-icons">{{ 'fullscreen' }}</i>
        </button>
        <button class="sidebar-menu" [ngClass]="{ active: config['sidebarIsOpen'] }" (click)="sidebarToggle()">
          <app-icon name="menu"></app-icon>
        </button>
      </div>
      <div [hidden]="!config.currentPageNumber" class="app-nav-control">
        <button (click)="prevPage()" [class.disabled]="config.currentPageNumber <= 0">
          <app-icon name="chevron-left"></app-icon>
        </button>
        {{ config.currentPageNumber }} /
        {{ config.endPageNumber }}
        <button (click)="nextPage()" [class.disabled]="config.currentPageNumber >= config.endPageNumber">
          <app-icon name="chevron-right"></app-icon>
        </button>
        <app-icon name="slash"></app-icon>
        <button [ngClass]="{ disabled: config.scale === 100 }" (click)="scaleDown()">
          <app-icon name="remove"></app-icon>
        </button>
        {{ config.scale }}%
        <button (click)="scaleUp()">
          <app-icon name="add"></app-icon>
        </button>
      </div>
      <div class="basket-button" [ngClass]="{ active: config['isBasketVisible'] }" (click)="openBasket()">
        <button>
          <app-icon name="setting-rounded"></app-icon>
        </button>
        {{ basket | basketCount : config }}
      </div>
    </nav>
  </ng-container>
</ng-container>
